import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * P2 — ADMIN_CREDIT grouped by idempotency-key prefix. Most of the value lands
 * in the undifferentiated `manual:<n>` bucket: the schema carries no source
 * attribution past that prefix, so `unattributedUsdt` states the limit rather
 * than the DTO implying a granularity that does not exist.
 */
export const ArenaOpsMoneyHouseInjectionResponseSchema = z.object({
  sources: z.array(
    z.object({
      sourceKey: z.string(),
      label: z.string(),
      movementCount: z.number().int(),
      /** Face value granted. */
      amountUsdt: ArenaOpsUsdtSchema,
      /**
       * What reached the economy. Identical to `amountUsdt` for the ledger
       * sources, which credit a balance directly; for tickets the two diverge,
       * because a ticket that expires unused issued face value and landed
       * none. Render both, or the panel overstates what the house spent.
       */
      landedUsdt: ArenaOpsUsdtSchema,
    }),
  ),
  totalUsdt: ArenaOpsUsdtSchema,
  totalLandedUsdt: ArenaOpsUsdtSchema,
  unattributedUsdt: ArenaOpsUsdtSchema,
  /** `null` when the window injected nothing — a share of nothing is unmeasured, and 0.0% reads as a measurement. */
  unattributedRatio: z.string().nullable(),
});
export type ArenaOpsMoneyHouseInjectionResponse = z.infer<typeof ArenaOpsMoneyHouseInjectionResponseSchema>;
